import fetchHandler from '../tracking/fetchHandler'
import { getUserSessionId } from './userAuthStore'
import { firebaseDomain, cloudFunctionDomain, uploadDomain } from '../domain'
import { isNetworkError } from '../../content-manager/utils/is-network-error'
import { sendRollbarWarning } from '../tracking/rollbar'

var respMiddlewareSubscribersObject = {}
var respMiddlewareSubscribers = []
function subscribeToAuthFetchResponses(id, subscriber) {
  respMiddlewareSubscribersObject[id] = subscriber
  respMiddlewareSubscribers = Object.values(respMiddlewareSubscribersObject)
}

// Session-level preference: once cloudfunctions.net is blocked,
// skip it for the rest of the session to avoid repeated failed attempts.
var useUploadFallback = false

function resetUploadFallback() {
  useUploadFallback = false
}

const authFetchHandler = async (url, options, acceptedErrorCodes, useDirectUrl = false) => {
  const userSessionId = getUserSessionId()
  const headersClone = options?.headers ?? {}
  const headers = {...headersClone, Authorization: 'Bearer ' + userSessionId}

  if (!useDirectUrl) {
    const resp = await fetchHandler(`${firebaseDomain}/${url}`, {...options, headers}, acceptedErrorCodes)
    respMiddlewareSubscribers.forEach(subscriber => subscriber(resp.clone()))
    return resp
  }

  // For file uploads (useDirectUrl=true):
  // If we already know cloudfunctions.net is blocked, go straight to fallback
  const domain = useUploadFallback ? uploadDomain : cloudFunctionDomain

  try {
    const resp = await fetchHandler(`${domain}/${url}`, {...options, headers}, acceptedErrorCodes)
    respMiddlewareSubscribers.forEach(subscriber => subscriber(resp.clone()))
    return resp
  } catch (err) {
    // On network error when trying cloudfunctions.net, fall back to Firebase Hosting
    if (!useUploadFallback && isNetworkError(err)) {
      useUploadFallback = true
      sendRollbarWarning('File upload fallback activated: cloudfunctions.net blocked, routing via /upload', {
        url,
        errorMessage: err.message,
      })
      const resp = await fetchHandler(`${uploadDomain}/${url}`, {...options, headers}, acceptedErrorCodes)
      respMiddlewareSubscribers.forEach(subscriber => subscriber(resp.clone()))
      return resp
    }
    throw err
  }
}

export { subscribeToAuthFetchResponses, resetUploadFallback }
export default authFetchHandler
